import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
 
import LOG, { log } from "../../../UTIL/LOG";
import Cue from "../../../UTIL/Instances/Cue";
import CueProgression from "../../../UTIL/Instances/CueProgression";
import ARRAY from "../../../UTIL/ARRAY";
import GameInstance from "../GameInstance";
import MissionInstance from "./MissionInstance";
 
class Missions
{
    public conquer              : CONQUER;
 
    private vars                : any;
    private randomCategory      : Cue = new Cue( true );
    private data                : any;
    private missionCues         : any = {};
    private progression         : CueProgression = new CueProgression( "linear", 6 );

    private state               : any = { progression:0, active:[] };
    private stateID             : string = "Missions";
    private gameInstance        : GameInstance;
 
    public items                : any = {};
    private length              : number = 0;
 
    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
  
        let data            = this.progression.patterns.data;

        data.linear0.push( [ "FTUE", "FTUE", "FTUE" ] );
        data.linear1.push( [ "Score", "GameAction", "GameAction" ] ); //PlayWithFriend
        data.linear2.push( [ "GameActionTime", "CoinEarn", "Purchase" ] );
        data.linear3.push( [ "ScoreTime", "GameAction", "WinGames" ] );
        data.linear4.push( [ "GameAction", "GameActionTime", "WinGames" ] );
        data.linear5.push( [ "Score", "ScoreTime", "GameAction" ] ); //PlayWithFriend
        data.endless.push( [ "GameAction", "GameActionTime", "GameAction", "Score", "ScoreTime", "Score", "GameAction", "GameAction", "ScoreTime",  "CoinEarn", "Purchase", "PlayGames", "WinGames", "Survive" ] ); //"PlayWithFriend", "PlayWithFriend",
    }

    public async set( data:any ) : Promise<any>
    {
        let results : any = await this.conquer.do( ACTIONS.GAME_MISSIONS_SET, { gameID:this.vars.gameID, data:data } );
 
        return Promise.resolve( this.processData( results.data ) );
    }

    public init( results:any )
    {
        this.vars           = { gameID:this.gameInstance.gameID };
 
        this.processData( results );
    }
 
    public async get( force?:boolean ) : Promise<any>
    {
        return Promise.resolve( this.getMission() );
    }
 
    private processData( raw : any )
    {
        this.reset();

        if( !raw ) return;

        var index       : any = {};
 
        var array       : any;
        var patterns    : any;
    
        var mission     : any;
        var KEYCount     = 0;

        this.data       = {};

        // INDEX

        for( let label in raw )
        {
            this.state[ label ] = 0;

            this.randomCategory.push( label );

            array           = raw[ label ];
            index[ label ]  = [];
 
            for( let n in array ) 
            {
                mission                     = array[n];
                mission.key                 = mission.key || "Mi"+ ( KEYCount++ );
                this.data[ mission.key ]    = mission;
                mission.pos                 = parseInt( n );

                if( !index[ label ][ mission.index ] ) index[ label ][ mission.index ] = [];
                index[ label ][ mission.index ].push( mission );

                this.length ++;
            }
 
        }

        // MISSION PROGRESSION 

        for( let label in index )
        {
            let category = index[ label ];

            let progression : CueProgression = this.missionCues[ label ] = new CueProgression( "linear", category.length );
            patterns        = progression.patterns.data; 

            for( let n=0; n<category.length; n ++ ) 
            {
                var item = category[n];

                patterns[ "linear"+n ].push( item );
                patterns[ "linear"+n ].isRandom = label != "FTUE";
            }

            // Endless mixes the last two levels of difficulty

            var a = ARRAY.copy( category[ category.length-1 ] ); 
            var b = ARRAY.copy( category[ category.length-2 ] || a );
  
            patterns.endless.push( ARRAY.push( a, b ) );
        }

        let state = this.state;
 
        ARRAY.extract( this.gameInstance.Data.data[ this.stateID ], state );
 
        this.progression.getPosition( state.progression );
        for( let category in this.missionCues ) if( state[ category ] ) this.missionCues[ category ].getPosition( state[ category ] );
 
        return this.getMission();
    }

    private getMission()
    {
        if( !this.length ) return null;

       // log("====== GET MISSION" );

        if( !this.state.progression ) 
        {
            //log( "no progression" );
            return this.setMission( this.getCategoryMission( this.progression.get() ) );
        }

        if( !this.state.active.length ) 
        {
            //log( "no active missions" );
            return this.setMission( this.getCategoryMission( this.progression.get() ) );
        }

       // log( "has active missions" );
 
        for( let n in this.state.active ) return this.setMission( this.data[ this.state.active[n] ] );
    }

    private setMission( missionVars?:any ) : any
    {
        if( !missionVars ) 
        {
            this.reset();
            return this.getMission();
        }

        let key         = missionVars.key;

        if( this.items[ key ] ) return this.items[ key ];

        let mission     = this.items[ key ] = new MissionInstance( this.gameInstance, missionVars );
 
        if( !this.state.active.includes( key ) )
        {
            this.state.active.push( key )
            this.save();
        }

        this.gameInstance.Signal.set( "MISSION:onSet", mission );
 
        return mission;
    }

    private getCategoryMission( category:string ) : any
    {   
        //if( ( category == "Purchase" || category == "CoinSpend" ) && !INVENTORY.hasAvailable() ) return getCategoryMission( randomCategory.get() );
        //if( category == "WinGames" && !CONFIG.GAME.SCORING.canWinGame ) return getCategoryMission( "PlayGames" ); 

        if( this.missionCues[ category ] ) return this.missionCues[ category ].get();
 
        if( category == "ScoreTime" )       return this.getReplacement( [ "GameActivityTime", "Score", "GameActivity" ] );
        if( category == "GameActivityTime") return this.getReplacement( [ "ScoreTime", "GameActivity", "Score" ] );
        if( category == "GameActivity")     return this.getReplacement( [ "GameActivityTime", "ScoreTime", "Score" ] );

        return this.getCategoryMission( this.randomCategory.get() );
    }

    private getReplacement( array : any )
    {
        for( var n in array ) if( this.missionCues[ array[n] ] ) return this.getCategoryMission( array[n] ); 
        return this.getCategoryMission( this.randomCategory.get() );
    }

    private save()
    {
        this.state.progression  = this.progression.position;

        for( let category in this.missionCues ) this.state[ category ] = this.missionCues[ category ].position;

        this.gameInstance.Data.set( this.stateID, this.state );
    }

    public reset()
    {
        for( let n in this.items ) this.items[n].disable();

        this.items = {};
        this.state = { progression:0, active:[] };
        this.progression.reset();
        for( let category in this.missionCues ) this.missionCues[ category ].reset();
    }

    public remove( missionKey:string )
    {
        if( !this.items[ missionKey ] ) return;
 
        let mission : MissionInstance =  this.items[ missionKey ];

        delete this.items[ missionKey ]; 

        if( mission ) mission.remove();

        if( !this.state.active.includes( missionKey ) ) return;
        ARRAY.removeItem( this.state.active, missionKey );

        this.save();
    }
 
}

export default Missions;